import '../util/aria.js';
import { html, property, query, customElement } from 'lit-element';
import { cssResult } from '../util/css.js';
import { __decorate, __metadata } from 'tslib';
import { Ripple } from '../ripple/ripple.js';
import { ButtonBehavior } from '../behavior/button/button-behavior.js';
import '../ripple/index.js';
import styles from './button.scss.js';

let Button = class Button extends ButtonBehavior {
    constructor() {
        super(...arguments);
        this.inverted = false;
        this.fab = false;
        this.outlined = false;
        this.noRipple = false;
        this.flat = false;
        this.role = 'button';
    }
    render() {
        return html` <wl-ripple id="ripple" overlay .target="${this}" ?disabled="${this.disabled || this.noRipple}"></wl-ripple> <slot></slot> ${this.renderFormElement()} `;
    }
};
Button.styles = [
    ...ButtonBehavior.styles,
    cssResult(styles)
];
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Button.prototype, 'inverted', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Button.prototype, 'fab', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Button.prototype, 'outlined', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Button.prototype, 'noRipple', void 0);
__decorate([
    property({
        type: Boolean,
        reflect: true
    }),
    __metadata('design:type', Boolean)
], Button.prototype, 'flat', void 0);
__decorate([
    property({
        type: String,
        reflect: true
    }),
    __metadata('design:type', String)
], Button.prototype, 'role', void 0);
__decorate([
    query('#ripple'),
    __metadata('design:type', Ripple)
], Button.prototype, '$ripple', void 0);
Button = __decorate([customElement('wl-button')], Button);

export { Button };
